import { Card, CardContent, Tooltip } from "@material-ui/core";
import React, { Component } from "react";
import PeningkatanPengelolaanStandar from "./content/PeningkatanPengelolaanStandar";
// import PeningkatanStandar from "./content/PeningkatanStandar";
class Peningkatan extends Component {
    
    render(){
        
        return(
            <>
                <PeningkatanPengelolaanStandar/>
            </>
        )
    }
}
export default Peningkatan;